import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Collapse, IconButton, styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const SectionCard = styled(Box)(({ theme }) => ({
  backgroundColor: '#f0f8ff',
  padding: '12px',
  borderRadius: '6px',
  marginBottom: '12px',
  border: '1px solid #b3d9ff',
  position: 'relative',
  '& .section-title': {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#00798E',
    marginBottom: '12px',
    paddingBottom: '6px',
    borderBottom: '1px solid #d0e8f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '0',
      top: '12px',
      width: '3px',
      height: '13px',
      backgroundColor: '#4caf50',
      borderRadius: '2px',
    },
  },
  '& .section-content': {
    paddingLeft: '0',
    paddingTop: '12px',
  },
}));

const SectionTitleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '13px',
  fontWeight: 'bold',
  color: '#00798E',
  marginBottom: '12px',
  paddingBottom: '6px',
  borderBottom: '1px solid #d0e8f0',
  paddingLeft: '8px',
  position: 'relative',
}));

function SectionWrapper({ title, icon: Icon, children, defaultExpanded = true, collapsible = true }) {
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  return (
    <SectionCard>
      <SectionTitleBox
        onClick={() => collapsible && setExpanded(!expanded)}
        sx={{ cursor: collapsible ? 'pointer' : 'default', userSelect: 'none' }}
      >
        {!collapsible && (
          <Box sx={{
            position: 'absolute',
            left: '0',
            top: '12px',
            width: '3px',
            height: '13px',
            backgroundColor: '#4caf50',
            borderRadius: '2px',
          }} />
        )}
        {Icon && <Icon sx={{ fontSize: 16, color: '#00798E' }} />}
        <Typography sx={{ fontSize: '13px', fontWeight: 'bold', color: '#00798E', flex: 1 }}>
          {title}
        </Typography>
        {collapsible && (
          <IconButton size="small" sx={{ color: '#00798E', p: 0.5 }}>
            {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </IconButton>
        )}
      </SectionTitleBox>

      <Collapse in={expanded}>
        <Box sx={{ pl: 1.5, pr: 1, pb: 1 }}>
          {children}
        </Box>
      </Collapse>
    </SectionCard>
  );
}

SectionWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  children: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  collapsible: PropTypes.bool,
};

export default SectionWrapper;
